import * as React from "react";

// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { MeasuredContext } from "@fluentui/react";
import { SLOT_ELEMENT_TYPE_SYMBOL } from "@fluentui/react-utilities";

// eslint-disable-next-line no-restricted-imports
import { useAppSplitButton } from "@1js/acui-button/lib/Next";
import { shouldShadowRender } from "@1js/acui-shadow-rendering";

import { RibbonSplitButtonPrimaryButton } from "./RibbonSplitButtonPrimaryButton";
import { RibbonSplitButtonMenuButton } from "./RibbonSplitButtonMenuButton";
import { RibbonSplitButtonPrimaryToggleButton } from "./RibbonSplitButtonPrimaryToggleButton";
import type { RibbonSplitButtonProps } from "./RibbonSplitButton.types";

export const useRibbonSplitButton = (
  props: RibbonSplitButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { shadowRenderMenu, dataAutomationType } = props;

  // Getting context and app settings to enable/disable shadow rendering
  const measuredContext = React.useContext(MeasuredContext);

  const state = useAppSplitButton(
    {
      ...props,
      dataAutomationType: dataAutomationType ?? "RibbonSplitButton",
      persistMenu: true,
      preventCalloutDismissOnScroll: true,
      shadowRenderMenu: shouldShadowRender(
        shadowRenderMenu,
        measuredContext.isMeasured
      ),
    },
    ref
  );

  // We want to render the corresponding Ribbon components instead of App components
  if (state.components) {
    state.components.primaryActionButton = props.toggleable
      ? RibbonSplitButtonPrimaryToggleButton
      : RibbonSplitButtonPrimaryButton;
    (state.primaryActionButton as any)[SLOT_ELEMENT_TYPE_SYMBOL] =
      props.toggleable
        ? RibbonSplitButtonPrimaryToggleButton
        : RibbonSplitButtonPrimaryButton;
    state.components.menuButton = RibbonSplitButtonMenuButton;
    (state.menuButton as any)[SLOT_ELEMENT_TYPE_SYMBOL] =
      RibbonSplitButtonMenuButton;
  }

  return state;
};
